// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_senhaCertificado__eKITv {
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
}

.styles_container_upload__q6\\+sm {
  align-items: center;
  background: #dfdddd;
  border: 3.5px dashed #18316e;
  border-radius: 8px;
  color: #868686;
  display: flex;
  flex-direction: column;
  height: 200px;
  justify-content: center;
  margin-bottom: 0.3rem;
  position: relative;
  transition: 500ms all;
  width: 100%;
  &:hover {
    background: #c7c7c7;
    border-color: #1f3a7e;
    color: #5e5d5d;
  }
}

.styles_paragrafo__JbyuA{
  margin-top: 1rem;
}

.styles_input__pRSBG {
  cursor: pointer;
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
}

.styles_btnManual__83acH{
  background: #18316e !important;
  color: white !important;
  &:hover{
    background: #1f3a7e !important;
  }
}

.styles_btn_visualizador__ipq2m {
  background: #18316e !important;
  &:hover {
    background: #1f3a7e !important;
  }
}

.styles_container_btn__jJxRx {
  display: flex !important;
  justify-content: space-between !important;
  margin-top: 1rem;
  padding: 0 !important;
}

.styles_btn_close__BA\\+cC {
  border: 2px solid #18316e !important;
  color: #18316e !important;
  transition: 500ms all !important;
  &:hover {
    background: #18316e !important;
    border: 2px solid #18316e !important;
    color: #fff !important;
  }
}

.styles_btn_avancar__GeSM7 {
  background: #18316e !important;
}

.styles_labelField__I\\+Hqh {
  font-family: "Inter" !important;
  font-size: 12px;
}

.styles_btnDiscreto__D8LnF{
  color: #7c7c7c !important;
  font-size: .8rem !important;
}

.styles_containerBtnCertificado__DsJo9{
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.styles_btnProcuracao__dgZMh{
  background: #18316e !important;
  color: white !important;
  margin: .5rem 0;
  &:hover{
    background: #1f3a7e !important;
  }
}

.styles_containerDocumento__FworW{
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
  width: 100%;
}

.styles_documento__6Ubbz{
  max-width: 30rem;
}


.styles_botaoUpload__N0Q5T,
.styles_botaoUploadOk__6\\+YWQ {
  height: 2.5rem !important;
  font-size: 1rem !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-transform: capitalize !important;
  font-family: "Inter" !important;
  color: #fff !important;
}

.styles_botaoUpload__N0Q5T {
  border-radius: 4px !important;
  background-color: #4b6fc0 !important;
}

.styles_botaoUploadOk__6\\+YWQ {
  background-color: #31c96f !important;
}

`, "",{"version":3,"sources":["webpack://./src/pages/SelecionarTiposNegocioSimples/ModalArquivos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,8BAA8B;EAC9B;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;EACxB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".senhaCertificado {\n  display: flex;\n  flex-direction: column;\n  margin: 1rem 0;\n}\n\n.container_upload {\n  align-items: center;\n  background: #dfdddd;\n  border: 3.5px dashed #18316e;\n  border-radius: 8px;\n  color: #868686;\n  display: flex;\n  flex-direction: column;\n  height: 200px;\n  justify-content: center;\n  margin-bottom: 0.3rem;\n  position: relative;\n  transition: 500ms all;\n  width: 100%;\n  &:hover {\n    background: #c7c7c7;\n    border-color: #1f3a7e;\n    color: #5e5d5d;\n  }\n}\n\n.paragrafo{\n  margin-top: 1rem;\n}\n\n.input {\n  cursor: pointer;\n  height: 100%;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n}\n\n.btnManual{\n  background: #18316e !important;\n  color: white !important;\n  &:hover{\n    background: #1f3a7e !important;\n  }\n}\n\n.btn_visualizador {\n  background: #18316e !important;\n  &:hover {\n    background: #1f3a7e !important;\n  }\n}\n\n.container_btn {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-top: 1rem;\n  padding: 0 !important;\n}\n\n.btn_close {\n  border: 2px solid #18316e !important;\n  color: #18316e !important;\n  transition: 500ms all !important;\n  &:hover {\n    background: #18316e !important;\n    border: 2px solid #18316e !important;\n    color: #fff !important;\n  }\n}\n\n.btn_avancar {\n  background: #18316e !important;\n}\n\n.labelField {\n  font-family: \"Inter\" !important;\n  font-size: 12px;\n}\n\n.btnDiscreto{\n  color: #7c7c7c !important;\n  font-size: .8rem !important;\n}\n\n.containerBtnCertificado{\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n}\n\n.btnProcuracao{\n  background: #18316e !important;\n  color: white !important;\n  margin: .5rem 0;\n  &:hover{\n    background: #1f3a7e !important;\n  }\n}\n\n.containerDocumento{\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.documento{\n  max-width: 30rem;\n}\n\n\n.botaoUpload,\n.botaoUploadOk {\n  height: 2.5rem !important;\n  font-size: 1rem !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-transform: capitalize !important;\n  font-family: \"Inter\" !important;\n  color: #fff !important;\n}\n\n.botaoUpload {\n  border-radius: 4px !important;\n  background-color: #4b6fc0 !important;\n}\n\n.botaoUploadOk {\n  background-color: #31c96f !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"senhaCertificado": `styles_senhaCertificado__eKITv`,
	"container_upload": `styles_container_upload__q6+sm`,
	"paragrafo": `styles_paragrafo__JbyuA`,
	"input": `styles_input__pRSBG`,
	"btnManual": `styles_btnManual__83acH`,
	"btn_visualizador": `styles_btn_visualizador__ipq2m`,
	"container_btn": `styles_container_btn__jJxRx`,
	"btn_close": `styles_btn_close__BA+cC`,
	"btn_avancar": `styles_btn_avancar__GeSM7`,
	"labelField": `styles_labelField__I+Hqh`,
	"btnDiscreto": `styles_btnDiscreto__D8LnF`,
	"containerBtnCertificado": `styles_containerBtnCertificado__DsJo9`,
	"btnProcuracao": `styles_btnProcuracao__dgZMh`,
	"containerDocumento": `styles_containerDocumento__FworW`,
	"documento": `styles_documento__6Ubbz`,
	"botaoUpload": `styles_botaoUpload__N0Q5T`,
	"botaoUploadOk": `styles_botaoUploadOk__6+YWQ`
};
export default ___CSS_LOADER_EXPORT___;
